export default function AuditPage() {
  return (
    <div className="p-4 space-y-4">
      <h2 className="text-2xl font-semibold">Auditoria IA</h2>
      <p className="text-gray-600">Registro e métricas de uso da IA. (placeholder)</p>
    </div>
  )
}
